// Favourites page — shares the same React Query cache as header + ProductCard
import ProductCard from '../components/ProductCard';
import LoadingSpinner from '../components/LoadingSpinner';
import BackToHomeLink from '../components/BackToHomeLink';
import { useFrontendAuth } from '../hooks/useAuth';
import { getFavourites } from '../services/api.shop';
import { useProtectedQuery } from '../hooks/useProtectedQuery';
import { useTranslation } from '../context/TranslationContext';
import { translateWithFallback } from '../utils/translateWithFallback';

const Wishlist = () => {
    const { user, loading: authLoading } = useFrontendAuth();
    const { t } = useTranslation();
    const tr = (key: string, fb: string) => translateWithFallback(t, key, fb);

    const { data: favourites = [], isLoading, error } = useProtectedQuery({
        queryKey: ['favourites'],
        queryFn: getFavourites,
        staleTime: 10 * 60 * 1000,
    });

    if (authLoading || isLoading) return <LoadingSpinner />;
    if (!user)
        return (
            <p className="text-center mt-8">
                {tr('favourites.loginRequired', 'Please log in to view your favourites.')}
            </p>
        );
    if (error)
        return (
            <p className="text-center mt-8 text-red-500">
                {tr('favourites.loadError', 'Failed to load favourites. Please try again.')}
            </p>
        );

    return (
        <div className="mx-auto max-w-7xl py-4 sm:py-8">
            <BackToHomeLink />
            <h1 className="mb-6 text-2xl font-bold text-[var(--text-color)] sm:text-3xl">
                {tr('favourites.heading', 'Your Favourites')}
            </h1>
            {favourites.length === 0 ? (
                <p className="text-center text-gray-500">
                    {tr('favourites.empty', 'You have no favourite products yet.')}
                </p>
            ) : (
                <div className="product-grid">
                    {favourites.map((product) => (
                        <ProductCard
                            key={product.id}
                            product={product}
                            showPrice={true}
                            hideOwnBadge={false}
                            favourites={favourites}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};

export default Wishlist;
